<template>
  <div class="header-mobile">
    <img
      src="https://api.belladasemana.com.br/storage/freetour/pictures/featured-image-1.jpg"
      alt="Free Tour"
      width="376"
      height="250"
    />
    <div class="block-split__header mx-4 shadow-header">
      <div class="u-mb-md-3 mt-2">
        <h1>{{ translate.title }}</h1>
        <h3 class="u-mb-md-3">
          {{ translate.subTitle }}
        </h3>
        <a :href="linkEnsaioGratis" class="button btn-mobile">
          {{ translate.buttonTitle }}
          <i class="icon-arrow-right"></i>
        </a>
      </div>
    </div>
  </div>
  <div class="block-split__header mx-4 header-desktop">
    <div class="u-mb-md-3 mt-5">
      <h1>{{ translate.title }}</h1>
      <h3 class="u-mb-md-3">
        {{ translate.subTitle }}
      </h3>
      <a :href="linkEnsaioGratis" class="button">
        {{ translate.buttonTitle }}
        <i class="icon-arrow-right"></i>
      </a>
    </div>
  </div>
  <div class="block-split__header mx-4">
    <h4>
      {{ translate.benefits }}
    </h4>
    <p v-html="translate.subBenefits" class="subBenefits u-mb-2 u-mb-md-3"></p>
    <ul class="bulleted-list u-mb-5 u-mb-md-0">
      <li v-for="(list, index) in translate.listBenefits" :key="index">
        <img :src="IconeBds" alt="Icone BDS" width="17" height="18" />
        {{ list }}
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import tradutor from '../../tradutors/freetour'
  import IconeBds from 'assets/img/icone_BDS.png'
  import { localeStore } from '../../stores/locale'

  const storeLocale = localeStore()

  const translate = computed(() => {
    if (storeLocale.locale === 'pt-br') {
      return tradutor.portugues
    } else {
      return tradutor.ingles
    }
  })

  const linkEnsaioGratis = computed(() => {
    if (storeLocale.locale == 'pt-br')
      return 'https://secure.campaigner.com/CSB/Public/Form.aspx?fid=1936917&ac=gpym'

    return 'https://secure.campaigner.com/CSB/Public/Form.aspx?fid=1939772&ac=gpym'
  })
</script>

<style scoped lang="css">
  .button {
    color: #fff;
  }
  .btn-mobile {
    border: 2px solid #ffffff;
    color: #ffffff;
    font-family: 'Exo-2';
    font-size: 16px;
    letter-spacing: 0;
  }
  .block-split__header {
    padding-left: 85px;
    padding-top: 27px;
  }

  .block-split__header h1 {
    font-family: 'Bebas-Neue-Light';
    color: #000000;
    font-size: 64px;
    font-weight: 300;
    letter-spacing: 0;
    line-height: 77px;
  }

  .block-split__header h3 {
    color: #b20000;
    font-family: 'Roboto-Medium';
    font-size: 24px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 28px;
  }

  .block-split__header h4 {
    color: #b20000;
    font-family: 'Roboto-Medium';
    font-size: 24px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 28px;
  }

  .subBenefits {
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
  }
  .bulleted-list img {
    width: 17px;
    height: 18px;
    margin-right: 10px;
    object-fit: cover;
  }

  .bulleted-list li {
    color: #000000;
    font-family: 'Exo-2';
    font-size: 18px;
    letter-spacing: 0;
    line-height: 18px;
  }
  .header-mobile {
    display: none;
  }

  .header-desktop {
    display: block;
  }

  /* regras mobile 769vp */
  @media screen and (max-width: 769px) {
    .header-mobile {
      display: block;
    }

    .header-desktop {
      display: none;
    }

    .block-split__header {
      padding-left: 0px;
    }

    .header-mobile img {
      width: 100%;
      object-fit: cover;
      height: auto;
    }

    .shadow-header {
      -webkit-box-shadow: 0px -52px 58px 14px rgba(0, 0, 0, 1);
      -moz-box-shadow: 0px -52px 58px 14px rgba(0, 0, 0, 1);
      box-shadow: 0px -52px 58px 14px rgba(0, 0, 0, 1);
    }

    .block-split__header h1 {
      color: white;
      font-size: 50px;
      margin-top: -20px;
    }

    .block-split__header h3 {
      color: white;
    }

    .block-split__header h4 {
      padding-top: 40px;
    }

    .header-mobile .block-split__header {
      background-color: black;
      margin-right: 0px;
      margin-left: unset;
      padding-bottom: 70px;
    }

    .header-mobile .mx-4 {
      margin-right: 0px !important;
      margin-left: 0px !important;
      padding-left: 20px;
    }
    .block-split__header >>> h3 {
      font-size: 24px;
      width: 85%;
      margin-bottom: 30px;
    }
  }
</style>
